export { default } from "./HeroBackground";
export { default as useSpotlight } from "./useSpotlight";
